import { render, staticRenderFns } from "./select-item.vue?vue&type=template&id=8708fee4&scoped=true"
import script from "./select-item.vue?vue&type=script&lang=js"
export * from "./select-item.vue?vue&type=script&lang=js"
import style0 from "./select-item.vue?vue&type=style&index=0&id=8708fee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8708fee4",
  null
  
)

export default component.exports